// External libs
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

// Local libs
import Service from '../common/service';
import CreditsPolicyModel from './creditsPolicy.model';

/**
 * Service for managing Credits Policy data.
 *
 * Provides functionality to fetch and manage credit policies.
 *
 * @module CreditsPolicyService
 */
@Injectable({
  providedIn: 'root'
})
export class CreditsPolicyService extends Service<CreditsPolicyModel> {

  /** Store ongoing HTTP request subscriptions */
  public ongoingRequests: Subscription[] = [];

  constructor(httpClient: HttpClient) {
    super(httpClient, '/tradingcommunity/creditpolicy/');
  }

  /**
   * Retrieve all credit policies
   * @returns Promise<Array<CreditsPolicyModel>>
   */
  public getAllCreditPolicies(): Promise<Array<CreditsPolicyModel>> {
    return new Promise((resolve, reject) => {
      const request = this.httpClient
        .get<Array<CreditsPolicyModel>>(
          `${this.baseUrl}${this.serviceUrl}?pageSize=100&order=old`,
          this.httpOptions
        )
        .subscribe({
          next: (response) => resolve(response),
          error: (error: HttpErrorResponse) => reject(error)
        });

      this.ongoingRequests.push(request);
    });
  }

  /**
   * Cancel all ongoing HTTP requests to prevent memory leaks
   */
  public cancelOnGoingHttpRequests(): void {
    this.ongoingRequests.forEach(req => req?.unsubscribe?.());
    this.ongoingRequests = [];
  }
}
